export default __webpack_public_path__ + "static/media/logo-on-page.7b815a71.png";